var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000610352,
    width: 39.9999,
    height: 39.9998,
    rx: 19.9999,
    fill: "#9B60FC",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16672 26.5V13.5C9.16672 12.638 9.50913 11.8114 10.1186 11.2019C10.7281 10.5924 11.5548 10.25 12.4167 10.25H14.5834C15.4453 10.25 16.272 10.5924 16.8815 11.2019C17.491 11.8114 17.8334 12.638 17.8334 13.5V26.5C17.8334 27.362 17.491 28.1886 16.8815 28.7981C16.272 29.4076 15.4453 29.75 14.5834 29.75H12.4167C11.5548 29.75 10.7281 29.4076 10.1186 28.7981C9.50913 28.1886 9.16672 27.362 9.16672 26.5Z",
    stroke: "#9B60FC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3334 10.25H26.5001C27.6493 10.25 28.7515 10.7065 29.5642 11.5192C30.3769 12.3319 30.8334 13.4341 30.8334 14.5833V25.4167C30.8334 26.5659 30.3769 27.6681 29.5642 28.4808C28.7515 29.2935 27.6493 29.75 26.5001 29.75H24.3334M17.8334 20H26.5001M26.5001 20L23.2501 16.75M26.5001 20L23.2501 23.25",
    stroke: "#9B60FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.11cb84c1619a4c106327bf7f5f6e2435.svg";
export { ForwardRef as ReactComponent };